import { legacy_createStore as createStore, combineReducers, applyMiddleware } from "redux";
import { thunk } from "redux-thunk"; // redux-thunk v3 is a NAMED export
import sessionReducer from "./session";

// Notes:
// - redux v5 deprecates the old `createStore` in favor of Redux Toolkit's
//   configureStore. To avoid a larger refactor right now, we import it via
//   its `legacy_createStore` alias, which is exported in v5 specifically for
//   this kind of migration. Functionality is identical to v4 createStore.
// - redux-thunk v3 ships as a named export `thunk` (the default export was
//   removed in v3).

const rootReducer = combineReducers({
  session: sessionReducer,
});

const enhancer = applyMiddleware(thunk);

const configureStore = (preloadedState) => {
  return createStore(rootReducer, preloadedState, enhancer);
};

export default configureStore;
